import { render, staticRenderFns } from "./KInformation.vue?vue&type=template&id=64519ecc&scoped=true&"
import script from "./KInformation.vue?vue&type=script&lang=js&"
export * from "./KInformation.vue?vue&type=script&lang=js&"
import style0 from "./KInformation.vue?vue&type=style&index=0&id=64519ecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64519ecc",
  null
  
)

export default component.exports